var map = {
	"./Appreciating.png": 516,
	"./Calming.png": 188,
	"./FPA.png": 972,
	"./Fighting.png": 341,
	"./Surgery.png": 398,
	"./Unique.png": 782,
	"./background.jpeg": 192,
	"./bio.jpeg": 374,
	"./chrome.png": 229,
	"./fightingCancer.jpg": 61,
	"./firefox.png": 576,
	"./polarBear.jpg": 669,
	"./polarBear2.jpg": 395,
	"./polarBear3.jpg": 614,
	"./safari.png": 595
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;